module.exports = __webpack_public_path__ + "assets/ic-github.54ce78e1.svg";